import VODList from './VODList';

export default VODList;
